var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import { H3 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import Form from "@irati/ui/src/Form";
import { ValidationButton, Checkbox } from "@irati/ui/src/FormItem";
import Validation from "@irati/utils/validation";
import { Hr } from "@irati/ui/src/Layout";
import Link from "@irati/ui/src/Link";
import { Locale } from "@irati-web/fields/user";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import ContactPreferences from "@irati-web/account/src/components/ContactPreferences/ContactPreferences";
import userService from "@irati/identity/services/users";
import onboardingService from "@irati/onboarding/services/onboarding";
import OnboardingStep from "@irati/onboarding/enums/Step";
import tracking from "@irati-tracking/platform";
import { UserSource } from "@irati/types";
import withAuth from "@irati/auth/helpers/auth/withAuth";
var agreeSchema = Validation.bool().oneOf([true], "onboarding.termsAndConditions.checkBox.validation.agreeSchema");
var TermsAndConditions = /** @class */ (function (_super) {
    __extends(TermsAndConditions, _super);
    function TermsAndConditions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            termsAndConditions: false,
            marketingEmailsAllowed: true
        };
        _this.componentDidMount = function () {
            tracking.onBoarding("Step 3");
        };
        _this.handleTermsAndConditions = function () {
            var termsAndConditions = _this.state.termsAndConditions;
            _this.setState({
                termsAndConditions: !termsAndConditions,
                saving: undefined
            });
        };
        _this.handleMarketingEmailEnabled = function (marketingEmailsAllowed) {
            _this.setState({
                marketingEmailsAllowed: marketingEmailsAllowed,
                saving: undefined
            });
        };
        _this.handleSubmit = function () {
            var marketingEmailsAllowed = _this.state.marketingEmailsAllowed;
            var user = _this.props.auth.user;
            var data = {
                uuid: user.uuid,
                dateOfBirth: user.dateOfBirth,
                marketingEmailsAllowed: marketingEmailsAllowed
            };
            var saving = userService.update({ user: data }).then(function () {
                return onboardingService.completeStep(user, OnboardingStep.ACCEPT_GDPR).then(function () {
                    tracking.onBoardingComplete();
                    _this.setState({ saving: undefined });
                });
            });
            _this.setState({ saving: saving });
        };
        _this.handleLanguageChange = function (value) {
            var user = _this.props.auth.user;
            _this.setState({ loadingUserLanguage: true });
            userService.update({ user: { uuid: user.uuid, language: value } }).then(function () {
                _this.setState({ loadingUserLanguage: false });
            });
        };
        _this.shouldShowLanguageSelection = function () {
            var user = _this.props.auth.user;
            if (!user || !user.source) {
                return false;
            }
            var showFor = [UserSource.Push, UserSource.Pull, UserSource.Upload];
            return showFor.includes(user.source);
        };
        return _this;
    }
    TermsAndConditions.prototype.render = function () {
        var _a = this.state, saving = _a.saving, termsAndConditions = _a.termsAndConditions, marketingEmailsAllowed = _a.marketingEmailsAllowed, user = _a.user, loadingUserLanguage = _a.loadingUserLanguage;
        var formatMessage = this.props.formatMessage;
        return (React.createElement(React.Fragment, null,
            React.createElement(Form, null,
                user && this.shouldShowLanguageSelection() && (React.createElement(React.Fragment, null,
                    React.createElement(H3, { small: true },
                        React.createElement(FormattedMessage, { id: "onboarding.language.heading" })),
                    React.createElement(Form, null,
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12 },
                                React.createElement(Locale, { isLoading: loadingUserLanguage, value: user.language, onChange: this.handleLanguageChange })))))),
                React.createElement(H3, { small: true },
                    React.createElement(FormattedMessage, { id: "onboarding.termsAndConditions.heading" })),
                React.createElement(Para, null,
                    React.createElement(FormattedMessage, { id: "onboarding.termsAndConditions.para" })),
                React.createElement(Checkbox, { name: "termsAndConditions", onChange: this.handleTermsAndConditions, checked: termsAndConditions, validation: agreeSchema },
                    React.createElement(FormattedMessage, { id: "onboarding.termsAndConditions.fields.header" }),
                    " ",
                    React.createElement(Link, { href: formatMessage({ id: "onboarding.termsAndConditions.fields.link.href" }), target: "_blank" },
                        React.createElement(FormattedMessage, { id: "onboarding.termsAndConditions.fields.link.text" }))),
                React.createElement(Hr, null),
                React.createElement(ContactPreferences, { onChange: this.handleMarketingEmailEnabled, value: marketingEmailsAllowed }),
                React.createElement(ValidationButton, { primary: true, large: true, full: true, load: saving, loading: formatMessage({ id: "onboarding.termsAndConditions.button.saving" }), onClick: this.handleSubmit },
                    React.createElement(FormattedMessage, { id: "onboarding.termsAndConditions.button.confirm" })))));
    };
    return TermsAndConditions;
}(Component));
export default injectIntl(withAuth(TermsAndConditions));
